import { JsonInput } from "react-admin-json-view";
import {
  EditContextProvider,
  SimpleForm,
  TextInput,
  useEditController,
} from "react-admin";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { useParams } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";

export const SystemSettingEdit = (props: any) => {
  const { id } = useParams();
  const controller = useEditController({
    resource: "system-settings/crud",
    mutationMode: "pessimistic",
    id,
  });
  return (
    <EditContextProvider value={controller}>
      <SimpleForm>
        <PageTopBreadcrumb
          title="Configuração de sistema"
          firstPath="/#/system-settings/crud"
          secondTitle="Editando"
          thirdTitle={controller && controller.record && controller.record.name}
          actionType="show"
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader
            title="Configuração de sistema"
            // subheader="September 14, 2016"
          />
          <CardContent>
            <Grid container spacing={0.5}>
              <Grid item xs={12}>
                <TextInput source="id" fullWidth disabled helperText={false} />
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  source="name"
                  label="Nome"
                  fullWidth
                  helperText={false}
                />
                <JsonInput source="value" label="Valor" />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </EditContextProvider>
  );
};
